import { head } from 'lodash';
import { FunctionComponent } from 'react';
import {
  FormFieldError,
  FormFieldInput,
  FormFieldLabel,
  StyledFormField,
} from './FormField.styled';
import { FormFieldProps } from './types';

export const FormField: FunctionComponent<FormFieldProps> = props => {
  const { children, disabled = false, error, label, vertical = false, ...rest } = props;

  /**
   * Render form error when applicable
   */
  const renderError = () => {
    // Error rendering is disabled
    if (error === false) {
      return null;
    }

    // Retrieve message of the only or first error
    const message = Array.isArray(error) ? head(error)?.message : error?.message;
    return <FormFieldError>{message ?? '\u200b'}</FormFieldError>;
  };

  return (
    <StyledFormField $vertical={vertical} {...rest}>
      <FormFieldLabel $disabled={disabled}>{label}</FormFieldLabel>
      <FormFieldInput>{children}</FormFieldInput>
      {renderError()}
    </StyledFormField>
  );
};
